// Utils/isUser.js
const isUser = (role) => {
    if (role === "user" || role === "admin") {
        return true;
    } else {
        return false;
    }
}

export default isUser;